import { render, staticRenderFns } from "./Poll.vue?vue&type=template&id=0a8ad7d4"
import script from "./Poll.vue?vue&type=script&lang=js"
export * from "./Poll.vue?vue&type=script&lang=js"
import style0 from "./Poll.vue?vue&type=style&index=0&id=0a8ad7d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports